import { ReactElement } from 'react';
import { useEntity, TabNav } from 'components';
import { Link, NavLinkProps, useMatch, useResolvedPath } from 'react-router-dom';
import type { Vendor } from 'modules/supplier/vendor/types';
import { Outlet } from 'modules/supplier/outletOrServiceCategory/types';
import { productTypeNavItems } from 'modules/supplier/products/ProductTypeNav';

export function VendorNav(): ReactElement | null {
  const { item } = useEntity<Vendor>();
  const isOutlet = useMatch(useResolvedPath('outlets/:id/*').pathname);

  if (isOutlet && isOutlet.params.id !== 'create') {
    return null;
  }

  const nav: NavLinkProps[] = [
    {
      to: 'outlets',
      children: 'Outlets',
    },
    {
      to: 'price_lists',
      children: 'Price lists',
    },
    {
      to: '',
      end: true,
      children: 'Update',
    },
  ];

  return (
    <div className="container-fluid header ">
      <div className="d-flex flex-row align-items-center">
        <div className="mb-2">
          <h2>{item.name}</h2>
        </div>
      </div>
      <TabNav nav={nav} />
    </div>
  );
}

export function OutletNav({ vendor }: { vendor: Vendor }): ReactElement {
  const { item } = useEntity<Outlet>();

  const nav: NavLinkProps[] = [
    ...productTypeNavItems(item.type, item.product_counts ?? {}),
    {
      to: '',
      end: true,
      children: 'Update',
    },
  ];

  return (
    <div className="container-fluid header ">
      <div className="d-flex flex-row align-items-center">
        <div className="mb-2">
          <h2>
            <Link to="../">{vendor.name}</Link> &rarr;
            {item.name}
          </h2>
        </div>
      </div>
      <TabNav nav={nav} />
    </div>
  );
}
